<div class="timeline-container" *ngIf="timelineItems && timelineItems.length">
    <div class="timeline-item-line"></div>
    <div class="timeline-items">
        <div *ngFor="let item of timelineItems" class="timeline-item">
            <div class="timeline-date-container">
                <div class="timeline-date">
                    <h5>{{ item.date }}</h5>
                </div>
            </div>
            <div class="timeline-status-icon">
                <lsq-icon
                    *ngIf="!item.complete"
                    [type]="icons.Circle"
                    [color]="color.Yellow"
                ></lsq-icon>
                <lsq-icon
                    *ngIf="item.complete"
                    [type]="icons.Circle"
                    [color]="color.Green"
                ></lsq-icon>
            </div>
            <div class="timeline-data">
                <div class="timeline-title">
                    <h4>{{ item.title }}</h4>
                </div>
                <div class="timeline-details" *ngIf="item.details && item.details.length">
                    <div class="detail-item" *ngFor="let detail of item.details">
                        <div class="detail-icon">
                            <lsq-icon
                                *ngIf="!detail.complete"
                                class="close-icon"
                                width="10"
                                height="10"
                                [type]="icons.CloseSmall"
                                [color]="color.Black"
                            >
                            </lsq-icon>
                            <lsq-icon
                                *ngIf="detail.complete"
                                width="15"
                                height="15"
                                [type]="icons.Checkmark"
                                [color]="color.Black"
                            >
                            </lsq-icon>
                        </div>
                        <div class="detail-text">
                            <div class="detail-header">
                                <div class="detail-title">
                                    <p>{{ detail.title }}</p>
                                </div>
                            </div>
                            <div class="detail-description">
                                <h6>{{ detail.data }}</h6>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="timeline-spacer" *ngIf="!item.details || !item.details.length"></div>
            </div>
        </div>
        <div class="end-dot">
            <lsq-icon [type]="icons.Circle" [color]="color.Gray"></lsq-icon>
        </div>
    </div>
</div>
